export enum EntityType {
  CLUSTER = "CLUSTER",
  ORGANIZATION = "ORGANIZATION",
  PANEL = "PANEL",
  PROPERTY = "PROPERTY",
  STATION = "STATION",
  USER = "USER"
}
